import {
  SET_LIST,
  SET_RECSHARE,
  SET_TOTAL,
  SET_OFFSET,
  SET_MAX,
  SET_SORT,
  SET_ORDER,
  CLEAR,
  CHANGE_MEMBER
} from "./mutation-types";

export default {
  [CHANGE_MEMBER](state, payload) {
    const recshareMembers = state["recshareMembers"];
    recshareMembers.splice(payload.index, 1, payload.newMbr);
  },
  [SET_LIST](state, listItems) {
    state["recshareMembers"] = [...listItems];
  },
  [SET_TOTAL](state, total) {
    state["total"] = total;
  },
  [SET_RECSHARE](state, recshare) {
    state["recshare"] = recshare;
  },
  [SET_OFFSET](state, offset) {
    state["offset"] = offset;
  },
  [SET_MAX](state, max) {
    state["max"] = max;
  },
  [SET_SORT](state, sort) {
    state["sort"] = sort;
  },
  [SET_ORDER](state, order) {
    state["order"] = order;
  },
  [CLEAR](state) {
    state["recshareMembers"] = [];
    state["recshare"] = 0;
    state["total"] = 0;
    state["max"] = 10;
    state["offset"] = 0;
    state["sort"] = "member.no";
    state["order"] = "ascending";
  },
};
